var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _c(
        "div",
        { staticClass: "sas-container" },
        [
          _c("NewComments", {
            attrs: { messageType: "12", siteId: _vm.siteId },
          }),
          _c("div", { staticClass: "h-full bg-white" }, [
            _c("div", { staticClass: "row row2" }, [
              _c(
                "div",
                { staticClass: "left" },
                _vm._l(_vm.statusOption, function (v, k) {
                  return _c("div", { key: k, staticClass: "status" }, [
                    _c("div", { staticClass: "icon" }, [
                      _c("img", { attrs: { src: _vm.getIconSvg(v.icon) } }),
                    ]),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.$t(v.label))),
                    ]),
                  ])
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c("GuidanceTooltip", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.getUser.userType == "1",
                        expression: "getUser.userType == '1'",
                      },
                    ],
                    staticClass: "tip",
                    attrs: {
                      content: _vm.$t("sas_tip_html"),
                      size: 20,
                      iconSize: 15,
                      jumpLink: _vm.$t("sas_tip_link"),
                    },
                  }),
                  _c("div", { staticClass: "split" }),
                  _c(
                    "div",
                    {
                      class: [
                        "table-column-control",
                        _vm.anyHidden ? "table-column-control-active" : "",
                      ],
                      on: { click: _vm.onTableColumnControlClick },
                    },
                    [
                      _vm._m(0),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("table_columns_display_btn"))),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "split" }),
                  _c(
                    "div",
                    {
                      class: [
                        "clean-filter",
                        _vm.milestoneQueryList.length > 0 ||
                        this.getEntityIds.length !== this.entityDataTotalSize ||
                        this.tableFilter.fileName ||
                        this.tableFilter.startCommentDate
                          ? "clean-filter-active"
                          : "",
                      ],
                      on: { click: _vm.clearFilter },
                    },
                    [
                      _c("img", {
                        staticClass: "table-setting-icon",
                        attrs: { src: require("@/assets/img/icon-screen.svg") },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("clear_filter")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row row2" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "row2-right-btn wl-green",
                      attrs: {
                        icon: "el-icon-download",
                        disabled:
                          _vm.tableSelect.show ||
                          !_vm.hasPermission("download"),
                      },
                      on: { click: _vm.onBatchDownloadClick },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.getUser.userType == "1",
                          expression: "getUser.userType == '1'",
                        },
                      ],
                      staticClass: "row2-right-btn wl-green",
                      attrs: {
                        icon: "el-icon-message",
                        disabled: _vm.tableSelect.show,
                      },
                      on: { click: _vm.onNoticeProgressClick },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("Notify_Client_About_Report_Progress")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.getUser.userType == "1",
                          expression: "getUser.userType == '1'",
                        },
                      ],
                      staticClass: "row2-right-btn wl-green",
                      attrs: {
                        icon: "el-icon-message",
                        disabled: _vm.tableSelect.show,
                      },
                      on: { click: _vm.onNoticeDraftClick },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("Notify_Client_About_Uploaded_Draft_Reports")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "row2-right-btn wl-green svg-btn",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: { click: _vm.onExportClick },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("export_statutory_list")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "row2-right-btn wl-green svg-btn",
                      attrs: {
                        disabled:
                          _vm.tableSelect.show ||
                          !_vm.hasPermission("download"),
                      },
                      on: { click: _vm.onExportFileLogClick },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BATCH_export")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { class: [_vm.tableSelect.show ? "table-multiselect" : "table"] },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading",
                      },
                    ],
                    ref: "SasTable",
                    attrs: {
                      data: _vm.tableData,
                      height: "100%",
                      border: "",
                      "row-class-name": "table-row",
                      "cell-style": { height: "100%", padding: "0" },
                    },
                    on: { "selection-change": _vm.onTableSelectChange },
                  },
                  [
                    _vm.tableSelect.show
                      ? _c("el-table-column", { attrs: { type: "selection" } })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("TABLE_HEADER_ENTITIES"),
                        prop: "entityName",
                        align: "center",
                        "min-width": "150",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._l(
                      _vm.tableColumns.filter((v) => v.show),
                      function (v, k) {
                        return _c(
                          "el-table-column",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: v.show,
                                expression: "v.show",
                              },
                            ],
                            key: k,
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "level1-table-header" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "level1-table-header-text",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.milestoneName
                                              ),
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "fold-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.switchCollapse(
                                                    v,
                                                    v.collapse
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: v.collapse,
                                                      expression: "v.collapse",
                                                    },
                                                  ],
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content: _vm.$t("unfold"),
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !v.collapse,
                                                      expression: "!v.collapse",
                                                    },
                                                  ],
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content: _vm.$t("fold"),
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-minus",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            v.collapse
                              ? [
                                  _c("el-table-column", {
                                    attrs: { width: "150" },
                                  }),
                                ]
                              : _vm._l(
                                  v.childMilestoneBO.filter((v) => v.show),
                                  function (vv, kk) {
                                    return _c(
                                      "el-table-column",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: vv.show,
                                            expression: "vv.show",
                                          },
                                        ],
                                        key: kk,
                                        attrs: {
                                          width: vv.targetTimeSelected
                                            ? 250
                                            : 150,
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "header",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-level2-header",
                                                    },
                                                    [
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !vv.showTableColumnTooltip,
                                                            placement: "top",
                                                            effect: "light",
                                                          },
                                                        },
                                                        [
                                                          _c("div", {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                vv.milestoneName
                                                              ),
                                                            },
                                                            slot: "content",
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              class: [
                                                                "table-level2-label",
                                                              ],
                                                              on: {
                                                                mouseover:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.calcShowTableColumnTooltip &&
                                                                      _vm.calcShowTableColumnTooltip(
                                                                        vv
                                                                      )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                ref: `tooltip_text_${vv.id}`,
                                                                refInFor: true,
                                                                staticClass:
                                                                  "table-level2-label-text",
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      vv.milestoneName
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                !vv.accessFlag,
                                                              expression:
                                                                "!vv.accessFlag",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "onlyforkpmg-tip",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "for_kpmg_only"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "120",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function () {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("sas_status")
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "el-dropdown",
                                                      {
                                                        attrs: {
                                                          trigger: "click",
                                                        },
                                                        on: {
                                                          command:
                                                            _vm.onStatusFilterClick,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-dropdown-link",
                                                          },
                                                          [
                                                            _c("i", {
                                                              class: [
                                                                "table-level2-icon",
                                                                "el-icon-arrow-down",
                                                                vv.where
                                                                  .status > 0
                                                                  ? "el-icon-arrow-down-active"
                                                                  : "",
                                                              ],
                                                            }),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-menu",
                                                          {
                                                            attrs: {
                                                              slot: "dropdown",
                                                            },
                                                            slot: "dropdown",
                                                          },
                                                          _vm._l(
                                                            _vm.statusOption,
                                                            function (
                                                              status,
                                                              statusK
                                                            ) {
                                                              return _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  key: statusK,
                                                                  attrs: {
                                                                    command: {
                                                                      v: vv,
                                                                      s: status,
                                                                    },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.getIconSvg(
                                                                        status.icon
                                                                      ),
                                                                      width:
                                                                        "100%",
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "default",
                                                fn: function ({ row }) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                          effect: "light",
                                                          disabled:
                                                            !row
                                                              .mileStoneRecordList[
                                                              `${vv.id}`
                                                            ]
                                                              .stateChangedTime &&
                                                            !row
                                                              .mileStoneRecordList[
                                                              `${vv.id}`
                                                            ].stateChangeBy &&
                                                            _vm.calcRowStatusDisable(
                                                              row,
                                                              vv
                                                            ) !== -3,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "content" },
                                                          [
                                                            _vm.calcRowStatusDisable(
                                                              row,
                                                              vv
                                                            ) == -3
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "\n                                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "milestone_cannot_update_tooltip"
                                                                        )
                                                                      ) +
                                                                      "\n                                        "
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              row
                                                                                .mileStoneRecordList[
                                                                                `${vv.id}`
                                                                              ]
                                                                                .stateChangedTime,
                                                                            expression:
                                                                              "row.mileStoneRecordList[`${vv.id}`].stateChangedTime",
                                                                          },
                                                                        ],
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ACCOUNT_STATUS_UPDATE_BY"
                                                                          )
                                                                        ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "formatDateTime"
                                                                            )(
                                                                              row
                                                                                .mileStoneRecordList[
                                                                                `${vv.id}`
                                                                              ]
                                                                                .stateChangedTime
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              row
                                                                                .mileStoneRecordList[
                                                                                `${vv.id}`
                                                                              ]
                                                                                .stateChangeBy,
                                                                            expression:
                                                                              "row.mileStoneRecordList[`${vv.id}`].stateChangeBy",
                                                                          },
                                                                        ],
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ACCOUNT_STATUS_SPREAD_BY"
                                                                          )
                                                                        ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            row
                                                                              .mileStoneRecordList[
                                                                              `${vv.id}`
                                                                            ]
                                                                              .stateChangeBy
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown",
                                                          {
                                                            attrs: {
                                                              trigger: "click",
                                                              disabled:
                                                                _vm.calcRowStatusDisable(
                                                                  row,
                                                                  vv
                                                                ) < 0,
                                                            },
                                                            on: {
                                                              command:
                                                                _vm.onStatusCellChange,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "el-dropdown-link",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getIconsvgByRow(
                                                                      row,
                                                                      vv
                                                                    ),
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                }),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-caret-bottom el-icon--right",
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-dropdown-menu",
                                                              {
                                                                attrs: {
                                                                  slot: "dropdown",
                                                                },
                                                                slot: "dropdown",
                                                              },
                                                              _vm._l(
                                                                _vm.statusOption,
                                                                function (
                                                                  status,
                                                                  statusK
                                                                ) {
                                                                  return _c(
                                                                    "el-dropdown-item",
                                                                    {
                                                                      key: statusK,
                                                                      attrs: {
                                                                        command:
                                                                          {
                                                                            row,
                                                                            status,
                                                                            vv,
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "status-dropdown-img",
                                                                          attrs:
                                                                            {
                                                                              src: _vm.getIconSvg(
                                                                                status.icon
                                                                              ),
                                                                              width:
                                                                                "100%",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        vv.targetTimeSelected
                                          ? _c("el-table-column", {
                                              attrs: {
                                                width: "170",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "header",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showCellDatePicker(
                                                                  vv
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.getUser
                                                                      .userType ==
                                                                    "1",
                                                                  expression:
                                                                    "getUser.userType == '1'",
                                                                },
                                                              ],
                                                              class: [
                                                                "table-level2-icon",
                                                                "el-icon-date",
                                                                vv.where
                                                                  .targetTime
                                                                  ? "el-icon-arrow-down-active"
                                                                  : "",
                                                              ],
                                                            }),
                                                            _c(
                                                              "el-date-picker",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm
                                                                        .getUser
                                                                        .userType ==
                                                                      "1",
                                                                    expression:
                                                                      "getUser.userType == '1'",
                                                                  },
                                                                ],
                                                                ref: `cellDatePicker_${vv.id}`,
                                                                refInFor: true,
                                                                staticStyle: {
                                                                  visibility:
                                                                    "hidden",
                                                                  position:
                                                                    "absolute",
                                                                  top: "0",
                                                                  left: "0",
                                                                  "z-index":
                                                                    "-1",
                                                                },
                                                                attrs: {
                                                                  type: "date",
                                                                  clearable: false,
                                                                  size: "mini",
                                                                  "value-format":
                                                                    "yyyy-MM-dd",
                                                                },
                                                                on: {
                                                                  change: (e) =>
                                                                    _vm.onTargetTimeFilterChange(
                                                                      e,
                                                                      vv
                                                                    ),
                                                                },
                                                                model: {
                                                                  value:
                                                                    vv.where
                                                                      .targetTime,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        vv.where,
                                                                        "targetTime",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "vv.where.targetTime",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(
                                                              "\n                                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "target_datetime"
                                                                  )
                                                                ) +
                                                                "\n                                "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "DatePickerPopover",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "5px",
                                                            },
                                                            attrs: {
                                                              value:
                                                                vv.where
                                                                  .targetTimeFilter,
                                                              hidePopperSearch:
                                                                (e) =>
                                                                  _vm.onTargetTimeWhereFilterChange(
                                                                    e,
                                                                    vv
                                                                  ),
                                                            },
                                                            on: {
                                                              "update:value":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$set(
                                                                    vv.where,
                                                                    "targetTimeFilter",
                                                                    $event
                                                                  )
                                                                },
                                                            },
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-date-picker", {
                                                          staticClass:
                                                            "cell-targetDate-picker",
                                                          attrs: {
                                                            type: "date",
                                                            placeholder: _vm.$t(
                                                              "table_placeholder_deadline"
                                                            ),
                                                            size: "mini",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            disabled:
                                                              [1, 4].includes(
                                                                scope.row
                                                                  .mileStoneRecordList[
                                                                  `${vv.id}`
                                                                ].state
                                                              ) ||
                                                              _vm.getUser
                                                                .userType ==
                                                                "2",
                                                          },
                                                          on: {
                                                            change: (e) =>
                                                              _vm.onTargetDateCellChange(
                                                                e,
                                                                scope.row,
                                                                vv
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .mileStoneRecordList[
                                                                `${vv.id}`
                                                              ].targetDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row
                                                                  .mileStoneRecordList[
                                                                  `${vv.id}`
                                                                ],
                                                                "targetDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.mileStoneRecordList[`${vv.id}`].targetDate",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                          ],
                          2
                        )
                      }
                    ),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("FORM_LABEL_attachmentList_short"),
                        width: "120",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t("TABLE_HEADER_fileNameList")
                                      ) +
                                      "\n                            "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "th-filter-down",
                                                },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      "el-icon-arrow-down",
                                                      _vm.fileName
                                                        ? "el-icon-arrow-down-active"
                                                        : "",
                                                    ],
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      [
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder:
                                              _vm.$t("fileNameKeyword"),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.fileName,
                                            callback: function ($$v) {
                                              _vm.fileName = $$v
                                            },
                                            expression: "fileName",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "attachment-count",
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFileNumClick(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        scope.row.attachmentBOList &&
                                          scope.row.attachmentBOList.length
                                          ? scope.row.attachmentBOList.length
                                          : 0
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("COMMON_UPLOAD"),
                        width: "70",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("i", {
                                class: [
                                  "wl-icon-upload",
                                  "el-icon-upload",
                                  !_vm.hasPermission("upload")
                                    ? "upload-icon-disabled"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onUploadClick(scope.row)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("TABLE_HEAD_COMMENTS"),
                        width: "85",
                        align: "center",
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                        "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.commentDate,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.commentDate = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex item-center justify-center",
                                },
                                [
                                  _c("i", {
                                    class: [
                                      scope.row.todayCommentCount > 0
                                        ? "wl-icon-messageBoard"
                                        : "wl-icon-messageBoardNull",
                                      "el-icon-s-comment",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCommentClick(scope.row)
                                      },
                                    },
                                  }),
                                  scope.row.todayCommentCount
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "message-today" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.todayCommentCount
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", [_vm._v("/")]),
                                      ])
                                    : _vm._e(),
                                  scope.row.messageCount > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " " + _vm._s(scope.row.messageCount)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tableSelect.show,
                    expression: "tableSelect.show",
                  },
                ],
                staticClass: "multi-func",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: { click: _vm.cancelBatchFunc },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: ["batch_download", "export_file_log"].includes(
                          _vm.tableSelect.mode
                        ),
                        expression:
                          "['batch_download', 'export_file_log'].includes(tableSelect.mode)",
                      },
                    ],
                    staticClass: "wl-green",
                    attrs: {
                      size: "mini",
                      disabled: _vm.tableSelect.value.length == 0,
                    },
                    on: { click: _vm.openBatchDownloadDialog },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          {
                            batch_download: "BATCH_DOWNLOAD",
                            export_file_log: "BATCH_export",
                          }[_vm.tableSelect.mode]
                        )
                      )
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: [
                          "send_email_progress",
                          "send_email_draft",
                        ].includes(_vm.tableSelect.mode),
                        expression:
                          "['send_email_progress', 'send_email_draft'].includes(tableSelect.mode)",
                      },
                    ],
                    staticClass: "wl-green",
                    attrs: {
                      size: "mini",
                      disabled: _vm.tableSelect.value.length == 0,
                    },
                    on: { click: _vm.openNoticeEmailDialog },
                  },
                  [_vm._v(_vm._s(_vm.$t("PAGE_CLIENTUSER_EMAIL")))]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c(
                  "el-pagination",
                  {
                    staticClass: "wl-pagination",
                    attrs: {
                      "current-page": _vm.page,
                      "page-size": _vm.limit,
                      layout: "prev, pager, next, slot, total",
                      total: _vm.total,
                    },
                    on: {
                      "current-change": (v) => {
                        _vm.page = v
                        _vm.getList()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: (e) => {
                                _vm.page = 1
                                _vm.limit = e
                                _vm.getList()
                              },
                            },
                            model: {
                              value: _vm.limit,
                              callback: function ($$v) {
                                _vm.limit = $$v
                              },
                              expression: "limit",
                            },
                          },
                          _vm._l(_vm.pageOptions, function (v) {
                            return _c("el-option", {
                              key: v.value,
                              attrs: { label: v.label, value: v.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("entity", {
        attrs: { onAdd: _vm.getList, entityData: _vm.entityData },
      }),
      _c("TableColumnControl", {
        ref: "tableColCtrl",
        attrs: {
          show: _vm.columnControl.show,
          treeData: _vm.tableColumns,
          parentPageLoadColumn: _vm.getColumnStatus,
          anyHidden: _vm.anyHidden,
        },
        on: {
          "update:show": function ($event) {
            return _vm.$set(_vm.columnControl, "show", $event)
          },
          "update:treeData": function ($event) {
            _vm.tableColumns = $event
          },
          "update:tree-data": function ($event) {
            _vm.tableColumns = $event
          },
          "update:anyHidden": function ($event) {
            _vm.anyHidden = $event
          },
          "update:any-hidden": function ($event) {
            _vm.anyHidden = $event
          },
        },
      }),
      _vm.commentsDialog.show
        ? _c("CommentsDialog", {
            ref: "commentsDlg",
            attrs: {
              reloadParents: _vm.getList,
              statuId: _vm.commentsDialog.statusId,
              show: _vm.commentsDialog.show,
              siteId: _vm.siteId,
            },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.commentsDialog, "show", $event)
              },
            },
          })
        : _vm._e(),
      _vm.upload.show
        ? _c("Upload", {
            ref: "Upload",
            attrs: {
              rowData: _vm.upload.rowData,
              secondMilestoneId: _vm.upload.secondMilestoneId,
            },
            on: { afterUploadAllFinish: _vm.afterUploadAllFinish },
          })
        : _vm._e(),
      _c("FileList", {
        attrs: {
          show: _vm.fileList.show,
          filelist: _vm.fileList.list,
          reloadList: _vm.getList,
        },
        on: {
          "update:show": function ($event) {
            return _vm.$set(_vm.fileList, "show", $event)
          },
        },
      }),
      _c("BatchSelectFile", {
        attrs: {
          show: _vm.tableSelect.showFileTable,
          filelist: _vm.tableSelect.fileList,
          milestoneColumns: _vm.tableColumns,
          mode: _vm.tableSelect.mode,
        },
        on: {
          "update:show": function ($event) {
            return _vm.$set(_vm.tableSelect, "showFileTable", $event)
          },
          closeBatch: _vm.closeBatch,
        },
      }),
      _c("Dashboard", {
        ref: "dashboardRef",
        attrs: {
          tableColumns: _vm.tableColumns,
          allEntityIds: this.allEntityIds,
          filterChange: _vm.getList,
          tableFilter: _vm.tableFilter,
        },
      }),
      _vm.getUser.userType == "1"
        ? _c("sendNoticeEmail", {
            attrs: {
              show: _vm.tableSelect.showEmailDialog,
              selectList: _vm.tableSelect.value,
              reloadList: _vm.getList,
              mode: _vm.tableSelect.mode,
            },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.tableSelect, "showEmailDialog", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        staticClass: "table-setting-icon",
        attrs: {
          src: require("@/assets/img/icon-table-setting.svg"),
          width: "100%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }